import { render, staticRenderFns } from "./NewMessageTypingIndicator.vue?vue&type=template&id=6beea6a2&scoped=true"
import script from "./NewMessageTypingIndicator.vue?vue&type=script&lang=js"
export * from "./NewMessageTypingIndicator.vue?vue&type=script&lang=js"
import style0 from "./NewMessageTypingIndicator.vue?vue&type=style&index=0&id=6beea6a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beea6a2",
  null
  
)

export default component.exports